import { Box, List } from '@iheartjane/reefer';

import { FilterCheckBox } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/filterCheckBox';
import {
  useProductSearchFilters,
  useSearchParamFilter,
} from '@jane/bloom/hooks/filters';
import { FilterCategoryLabel } from '@jane/bloom/hooks/filters/useProductSearchFilters';
import type { ProductSearchFilterTypeKeys } from '@jane/bloom/viewModels/productSearchFilters';

import { FilterActions } from './filterActions';

interface FilterCheckboxListProps {
  availableProductsCount?: number;
  /** Injected by FilterButtonWrapper */
  closePopover?: () => void;
  filterKey: ProductSearchFilterTypeKeys;
}

export function FilterCheckboxList({
  availableProductsCount,
  closePopover,
  filterKey,
}: FilterCheckboxListProps) {
  const { clearFilter } = useSearchParamFilter(filterKey);
  const { getProductSearchFilterOptions } = useProductSearchFilters();
  const filterOptions = getProductSearchFilterOptions(filterKey);

  return (
    <Box px={16} pt={16}>
      <List label={FilterCategoryLabel[filterKey]} mb={16}>
        {filterOptions.map((filter, i) => (
          <FilterCheckBox
            filterKey={filterKey}
            filter={filter}
            key={`${filterKey}-${i}-${filter.value}`}
          />
        ))}
      </List>
      <FilterActions
        availableProductsCount={availableProductsCount}
        handleClearAll={clearFilter}
        handleClose={closePopover}
        sticky
      />
    </Box>
  );
}
